import { POLICY_CONFIG_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import { PolicyMappingResponse } from "Types";
import {
  GetGroupRequest,
  GetOrganizationRequest,
  TransformedResponse,
  UpdateGroupRequest,
  UpdateGroupResponse,
  UpdateOrganizationRequest,
  UpdateOrganizationResponse,
} from "../types";
import { normalizePolicies } from "../utils";

const policyConfigApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOrganizationPolicy: build.query<
      TransformedResponse,
      GetOrganizationRequest
    >({
      query: (queryArg) => ({
        url: `${POLICY_CONFIG_ENDPOINT}/organization/${queryArg.organizationId}`,
      }),
      transformResponse: normalizePolicies,
      providesTags: ["OrganizationPolicy"],
    }),
    updateOrganizationPolicy: build.mutation<
      UpdateOrganizationResponse,
      UpdateOrganizationRequest
    >({
      query: (queryArg) => ({
        url: `${POLICY_CONFIG_ENDPOINT}/organization/${queryArg.organizationId}`,
        method: "POST",
        body: queryArg.body,
      }),
      invalidatesTags: ["OrganizationPolicy"],
    }),
    getGroupPolicy: build.query<TransformedResponse, GetGroupRequest>({
      query: (queryArg) => ({
        url: `${POLICY_CONFIG_ENDPOINT}/group/${queryArg.groupId}`,
      }),
      transformResponse: normalizePolicies,
      providesTags: ["GroupPolicy"],
    }),
    updateGroupPolicy: build.mutation<UpdateGroupResponse, UpdateGroupRequest>({
      query: (queryArg) => ({
        url: `${POLICY_CONFIG_ENDPOINT}/group/${queryArg.groupId}`,
        method: "POST",
        body: queryArg.body,
      }),
      invalidatesTags: ["GroupPolicy"],
    }),
    getPolicyMappings: build.query<PolicyMappingResponse, void>({
      query: () => ({
        url: `${POLICY_CONFIG_ENDPOINT}/policy-mappings`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { policyConfigApi };

export const {
  useGetOrganizationPolicyQuery,
  useUpdateOrganizationPolicyMutation,
  useGetGroupPolicyQuery,
  useUpdateGroupPolicyMutation,
  useGetPolicyMappingsQuery,
} = policyConfigApi;
